import { render, staticRenderFns } from "./water-consent-condition-type-fixed-date.vue?vue&type=template&id=2498807c&"
import script from "./water-consent-condition-type-fixed-date.vue?vue&type=script&lang=ts&"
export * from "./water-consent-condition-type-fixed-date.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports